import { defineStore } from 'pinia';

export const useUserPreferencesStore = defineStore('user-preferences', {
  state: () => ({
    navCollapsed: false,
  }),
  actions: {
    setNavTogglePreference(collapsed: boolean) {
      this.navCollapsed = collapsed;
      localStorage.setItem('navCollapsed', JSON.stringify(collapsed));
    },
    loadFromLocalStorage() {
      const saved = localStorage.getItem('navCollapsed');
      if (saved !== null) {
        this.navCollapsed = JSON.parse(saved);
      }
    },
  },
});
